export default __webpack_public_path__ + "static/media/Tilak's Resume.3f5f7a2b.pdf";